import { CrownIcon } from 'lucide-react';
import { Button, type ButtonProps } from '~/components/button';
import { cn } from '~/utils/cn';
import { useCreateCheckoutSession } from '@medizzy/payments';
import { useActivePromo } from '~/features/promo/use-active-promo';

interface LandingPurchaseButtonProps extends ButtonProps {
  period?: 'monthly' | 'yearly';
}

export function LandingPurchaseButton({
  period = 'monthly',
  className,
  ...restProps
}: LandingPurchaseButtonProps) {
  const { promo } = useActivePromo();
  const createCheckout = useCreateCheckoutSession({
    onSuccess: ({ url }) => {
      window.location.assign(url);
    },
  });

  function onClick() {
    createCheckout.mutate({
      period,
      return: 'landing',
      variant: promo !== null ? promo : 'default',
    });
  }

  return (
    <Button
      data-testid="landing-purchase-button"
      isLoading={createCheckout.isPending}
      variant="premium"
      size="lg"
      iconStart={<CrownIcon size={20} />}
      className={cn(
        'w-full font-semibold min-h-14 text-lg',
        'lg:w-auto',
        className,
      )}
      onClick={onClick}
      {...restProps}
    >
      Buy now!
    </Button>
  );
}
